export const TWITTER_REGEX = /^https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/;
export const TWITTER_REGEX_GLOBAL =
    /^https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/g;

export function isValidTwitterUrl(url: string): RegExpMatchArray | null {
    return url.match(TWITTER_REGEX);
}
